<div class="list-widget">
  <!-- Empty State -->
  @if (!listData()?.items?.length) {
    <div class="empty-state">
      <mat-icon class="empty-icon">list_alt</mat-icon>
      <p class="empty-message">Nessun elemento da visualizzare</p>
    </div>
  }
  <!--@if(labels.length) {
  <div class="labels flex justify-between mb-2">
    @for (label of labels; track label; let i = $index) {
      <div class="label-item">
        {{ label | translate }}
      </div>
}
  </div>
}-->

  <!-- List Content -->
  @if (listData()?.items?.length) {
    <mat-list class="widget-list">
      @for (
        item of listData().items;
        track trackByItemId(i, item);
        let i = $index
      ) {
        <mat-list-item
          class="list-item"
          [disabled]="lockedPatient"
          (click)="onItemClick(item)"
        >
          <!-- Item Content -->
          <div matListItemTitle>
            <div class="flex justify-between items-center">
              <div class="item-title" [ngClass]="item.id ? 'item-link' : ''">
                {{ item.label }}
              </div>
              @if (item.value) {
                <div class="item-status">
                  {{ item.value }}
                </div>
              }
            </div>
          </div>

          <!-- Divider (except last item) -->
          @if (i < listData().items.length - 1) {
            <mat-divider></mat-divider>
          }
        </mat-list-item>
      }
    </mat-list>
  }
</div>
